import { Flex, Button, Text } from '@chakra-ui/react';

import React from 'react';

const PaginationControls = ({
  currentPage,
  totalPages,
  onPageChange,
  className = 'w-full px-2 sm:px-4',
}) => {
  // Function to generate page numbers to display
  const getPageNumbers = () => {
    const delta = 1; // Number of pages to show before and after current page
    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, '...');
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < totalPages - 1) {
      rangeWithDots.push('...', totalPages);
    } else if (totalPages > 1) {
      rangeWithDots.push(totalPages);
    }

    return rangeWithDots;
  };

  return (
    <Flex
      justify="center"
      align="center"
      mt={4}
      mb={4}
      gap={[1, 2]}
      flexWrap="wrap"
      className={className}
    >
      <Button
        size={['xs', 'sm']}
        onClick={() => onPageChange(currentPage - 1)}
        isDisabled={currentPage <= 1}
        color="brand.primary"
        variant="outline"
        className="min-w-[70px] sm:min-w-[85px] hover:bg-brand.primary hover:text-white"
        borderColor="brand.primary"
        _hover={{
          bg: 'brand.primary',
          color: 'white',
        }}
        leftIcon={<span className="hidden sm:inline">←</span>}
      >
        <span className="sm:hidden">←</span>
        <span className="hidden sm:inline">Previous</span>
      </Button>

      <Flex gap={[1, 2]} display={['none', 'flex']}>
        {getPageNumbers().map((page, index) =>
          page === '...' ? (
            <Text
              key={`dots-${index}`}
              alignSelf="center"
              color="brand.primary"
              mx={1}
            >
              ...
            </Text>
          ) : (
            <Button
              key={index}
              size="sm"
              onClick={() => {
                if (typeof page === 'number' && page !== currentPage) {
                  onPageChange(page);
                }
              }}
              bg={currentPage === page ? 'brand.primary' : 'white'}
              color={currentPage === page ? 'white' : 'brand.primary'}
              borderColor="brand.primary"
              variant={currentPage === page ? 'solid' : 'outline'}
              className="min-w-[40px]"
              _hover={{
                bg: 'brand.primary',
                color: 'white',
              }}
            >
              {page}
            </Button>
          ),
        )}
      </Flex>

      {/* Mobile current page indicator */}
      <Text
        mx={2}
        fontSize={['sm', 'md']}
        fontWeight="medium"
        display={['block', 'none']}
        color="brand.primary"
      >
        {currentPage} / {totalPages}
      </Text>

      <Button
        size={['xs', 'sm']}
        onClick={() => onPageChange(currentPage + 1)}
        isDisabled={currentPage >= totalPages}
        color="brand.primary"
        variant="outline"
        className="min-w-[70px] sm:min-w-[85px]"
        borderColor="brand.primary"
        _hover={{
          bg: 'brand.primary',
          color: 'white',
        }}
        rightIcon={<span className="hidden sm:inline">→</span>}
      >
        <span className="hidden sm:inline">Next</span>
        <span className="sm:hidden">→</span>
      </Button>
    </Flex>
  );
};

export default PaginationControls;
